import React from 'react'
import { observer } from 'mobx-react'
import { DateCell, TableCell, TextCell } from 'components/Table'
import { SearchableUser } from 'iam/models/SearchableUser'
import { ImageCellContent } from 'components/Table/TableCell'

interface ClientUserManagementTableRowProps {
  user: SearchableUser
}

interface ClientUserManagementNameCellWithIndicatorProps {
  title?: string | null
  image?: string | null
  imageFallback?: string | null
  size?: number
  minWidth?: number
  noPadding?: boolean
  dataTest?: string
  online?: boolean
}

const ClientUserManagementNameCellWithIndicator = observer(function ImageCell({
  title,
  image,
  imageFallback,
  size,
  minWidth,
  noPadding,
  dataTest,
  online,
}: ClientUserManagementNameCellWithIndicatorProps) {
  return (
    <TableCell dataTest={dataTest}>
      <ImageCellContent
        title={title}
        image={image}
        size={size}
        imageFallback={imageFallback}
        minWidth={minWidth}
        noPadding={noPadding}
        online={online}
      />
    </TableCell>
  )
})

export default observer(({ user }: ClientUserManagementTableRowProps) => (
  <>
    <ClientUserManagementNameCellWithIndicator
      key={user.publicId}
      title={user.displayName}
      dataTest={`user-management-table-row-user-${user.publicId}`}
      online={user.online}
    />

    <TextCell>{user.email}</TextCell>

    <DateCell date={user.lastSeen} />

    <DateCell date={user.dateCreated} />
  </>
))
